<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label class="small-font-size">
            The path or value for the OrganizationId you're transferring the well to:
            <input type="text" [(ngModel)]="seConfiguration.OrganizationId" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label class="small-font-size">
            The context location for the wells you're transferring to:
            <input type="text" [(ngModel)]="seConfiguration.WellsToTransferContextPath" />
        </label>
    </div>
</div>
<div class="cell small-12 bold">
    Disposition:
</div>
<div class="cell small-12">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="alwaysDisposition" [(ngModel)]="seConfiguration.AlwaysUpdateDisposition" />
        <label aria-hidden="true" for="alwaysDisposition" class="inline">
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>&nbsp;
            <span class="control-label-text small-font-size"> Always Update Disposition <help-text [helpText]="'When checked, Disposition will always be updated to the provided value, even if blank.'"></help-text> </span>
        </label>
    </div>
</div>
<div class="cell small-12 checkbox small-font-size">
    Upon transfer, what value should the transferred well have?<help-text [helpText]="'Unless the checkbox is checked, Disposition will not change if left empty.'"></help-text>
    <input type="text" [(ngModel)]="seConfiguration.WellDispositionUponTransfer" />
</div>
<hr />
<div class="cell small-12 bold">
    Disposition Legacy Tracking:
</div>
<div class="cell small-12">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="alwaysLegacy" [(ngModel)]="seConfiguration.AlwaysUpdateLegacyTracking" />
        <label aria-hidden="true" for="alwaysLegacy" class="inline">
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>&nbsp;
            <span class="control-label-text small-font-size"> Always Update Legacy Tracking <help-text [helpText]="'When checked, Legacy Tracking will always be updated to the provided value, even if blank.'"></help-text> </span>
        </label>
    </div>
</div>
<div class="cell small-12 small-font-size">
    Upon transfer, what value should the transferred well have? <help-text [helpText]="'Unless the checkbox is checked, Disposition LegacyTracking will not change if left empty.'"></help-text>
    <input type="text" [(ngModel)]="seConfiguration.WellDispositionLegacyTrackingUponTransfer" />
</div>
<hr />
<div class="cell small-12 bold">
    Well Type Description:
</div>
<div class="cell small-12">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="alwaysTypeDescription" [(ngModel)]="seConfiguration.AlwaysUpdateTypeDescription" />
        <label aria-hidden="true" for="alwaysTypeDescription" class="inline">
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>&nbsp;
            <span class="control-label-text small-font-size"> Always Update Type Description <help-text [helpText]="'When checked, Type Description will always be updated to the provided value, even if blank.'"></help-text> </span>
        </label>
    </div>
</div>
<div class="cell small-12 checkbox small-font-size">
    Upon transfer, what value should the transferred well have?<help-text [helpText]="'Unless the checkbox is checked, Type Description will not change if left empty.'"></help-text>
    <input type="text" [(ngModel)]="seConfiguration.WellTypeDescriptionUponTransfer" />
</div>
<hr />
<div class="cell small-12 bold">
    Flag Changes:
</div>
<div class="cell small-12 small-font-size">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="withoutFiveAcres" [(ngModel)]="seConfiguration.WithoutFiveAcres" />
        <label aria-hidden="true" for="withoutFiveAcres" class="inline">
            <span class="control-label-text small-font-size">Are the transferred wells without 5 acres? </span>&nbsp;
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        </label>
    </div>
</div>

<div class="cell small-12 small-font-size">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="releaseOfLeaseProvided" [(ngModel)]="seConfiguration.ReleaseOfLeaseProvided" />
        <label aria-hidden="true" for="releaseOfLeaseProvided" class="inline">
            <span class="control-label-text small-font-size">Was a Release of Lease Provided for the transferred well? </span>&nbsp;
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        </label>
    </div>   
</div>

<div class="cell small-12 small-font-size">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="targetContextObjectIsArrayOfWells" [(ngModel)]="seConfiguration.TargetContextObjectIsArrayOfWells" />
        <label aria-hidden="true" for="targetContextObjectIsArrayOfWells" class="inline">
            <span class="control-label-text small-font-size">Is the target context object an array of wells, not an array of API #? </span>&nbsp;
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        </label>
    </div>
</div>

<div class="cell small-12 small-font-size">
    <div class="checkbox">
        <input class="show-for-sr" type="checkbox" id="updateGISOwnerAttributes" [(ngModel)]="seConfiguration.UpdateGISOwnerAttributes" />
        <label aria-hidden="true" for="updateGISOwnerAttributes" class="inline">
            <span class="control-label-text small-font-size">Should the GIS owner attribute data also be updated? </span>
            <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        </label>
    </div>
</div>
